import React from 'react';
import style from '../css/Promo.module.css';
import { FaGifts } from 'react-icons/fa6';

function Promo() {
	return (
		<div class={style.promo_banner}>
			<div className={style.textWrapper}>
				<FaGifts color="white" size={18} />
				<p class={style.text}>
					Get $500 for personal travel when your company joins Exporest | Learn
					more
				</p>
			</div>
		</div>
	);
}

export default Promo;
